import styled from 'styled-components';
import { FaSearch, FaPlus } from 'react-icons/fa';

export const Container = styled.div`
  padding: 0 30px;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 900px;
  padding: 50px 0;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  color: #fff;
`;

export const SearchBox = styled.div`
  margin-bottom: 30px;
  width: 100%;
  position: relative;

  input {
    width: 100%;
    padding: 10px 20px 10px 50px;
    border: none;
    border-radius: 24px;
    font: 400 20px 'Roboto', sans-serif;
    color: #fff;
    background: rgba(0, 0, 0, 0.1);

    transition: all 0.3s;

    &::placeholder {
      font: 300 16px 'Roboto', sans-serif;
      color: #fff;
    }

    &:focus {
      background: rgba(0, 0, 0, 0.3);
    }
  }
`;

export const SearchIcon = styled(FaSearch)`
  position: absolute;
  left: 18px;
  top: 12px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  margin-bottom: 25px;
  text-align: left;

  a {
    display: flex;
    justify-content: space-between;
    align-items: center;

    font: 700 18px 'Roboto', sans-serif;
    color: #fff;
    background: rgba(0, 0, 0, 0.4);
    transition: all 0.3s;

    padding: 20px;
    border-radius: 40px;

    &:hover {
      background: rgba(0, 0, 0, 0.6);
    }
  }
`;

export const AddQuestionIcon = styled(FaPlus)`
  margin-right: 10px;
`;

export const QuestionItem = styled.div`
  cursor: pointer;

  display: flex;
  flex-direction: column;
  width: 100%;

  background: rgba(0, 0, 0, 0.1);
  transition: all 0.3s;

  margin: 4px 0;
  padding: 20px;

  border-radius: 30px;

  strong {
    display: flex;

    font: 400 16px 'Roboto', sans-serif;

    h3 + h3 {
      margin-left: 15px;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: block;
      overflow: hidden;
    }
  }

  span {
    display: flex;
    flex-wrap: wrap;

    visibility: hidden;

    transition: max-height 0.8s;
    transition-delay: -0.6s;

    max-height: 0;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.3);

    strong {
      h3 {
        white-space: normal;
        overflow: visible;
      }
    }

    span {
      margin-top: 15px;
      margin-left: 38px;
      visibility: visible;
      max-height: 500px;
    }
  }
`;

export const TagItem = styled.small`
  font: 700 12px 'Roboto', sans-serif;

  background: #59c17c;
  padding: 5px;
  margin: 0 7px 5px 0;
  border-radius: 5px;
`;
